import type React from 'react';

import { Modal } from 'ui';

import classes from './ConfirmModal.module.scss';
import type { ConfirmModalProps } from './types';

/* design-fix 2026-10-09: подтверждение по Figma (Выход ученика - подтверждение):
   заголовок, пояснение, крестик, кнопки «Отмена» и основное действие. Логика onOk/onNo/onClose прежняя. */
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onOk,
  onNo,
  onClose,
  title,
  text,
  okLabel = 'Подтвердить',
  noLabel = 'Отмена',
  danger,
  zIndex,
}) => {
  const handleClose = () => {
    onClose?.();
  };

  const handleOk = () => {
    onOk?.();
    handleClose();
  };

  const handleNo = () => {
    onNo?.();
    handleClose();
  };

  return (
    <Modal
      open={Boolean(open)}
      onClose={handleClose}
      zIndex={zIndex}
      widthModal='min(440px, calc(100vw - 24px))'
    >
      <div className={classes.paper} role='alertdialog' aria-label={title || 'Подтверждение'}>
        <div className={classes.head}>
          <p className={classes.title}>{title || 'Подтвердите действие'}</p>
        </div>
        {text ? <p className={classes.text}>{text}</p> : null}
        <div className={classes.buttonsContainer}>
          <button type='button' className={classes.ghost} onClick={handleNo}>
            {noLabel}
          </button>
          <button
            type='button'
            className={`${classes.primary} ${danger ? classes.danger : ''}`}
            onClick={handleOk}
          >
            {okLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};
